<div mat-dialog-content>
  @switch (data.productClassifications) {
    @case (ProductClassifications.Equipment) {
      <div>
        <h2>Fjern tilbehør fra bestillingen</h2>
        <p>
          Er du sikker på at du vil fjerne tilbehør
          <strong>{{ product.name || product.equipment?.name }}</strong>
          ?
        </p>
      </div>
    }

    @case (ProductClassifications.MBBProduct) {
      <div>
        <h2>{{ product.isExistingSubscription ? 'Fjern alle endringer' : 'Fjern bredbånd fra bestillingen' }}</h2>
        <p>
          @if (product.isExistingSubscription) {
            Du tilbakestiller
            {{ product.existingOfferingName || product.name || product.subscription?.productName }} til slik det opprinnelig
            var før salget.
          } @else {
            Er du sikker på at du vil fjerne produkt
            <strong>{{ product.mbbRouter?.fullName || product.name }}</strong>
            @if (product.mbbSubscription?.id) {
              med abonnement
              <strong>{{ product.mbbSubscription.name }}</strong>
            }
            ?
          }
        </p>
      </div>
    }

    @case (ProductClassifications.VoiceProduct) {
      <div>
        <h2>{{ product.isExistingSubscription ? 'Fjern alle endringer' : 'Fjern abonnement fra bestillingen' }}</h2>
        <p>
          @if (product.isExistingSubscription) {
            Du tilbakestiller
            {{ product.existingOfferingName || product.name || product.subscription?.productName }} til slik det opprinnelig
            var før salget.
          } @else {
            Er du sikker på at du vil fjerne abonnement
            <strong>{{ product.offering?.name || product.name }}</strong>
            ?
          }
        </p>
      </div>
    }

    @case (ProductClassifications.Mobile) {
      <div>
        <p><strong>Fjern telefon fra bestillingen</strong></p>
        <p>
          Er du sikker på at du vil fjerne
          <strong>{{ product.mobilePhoneVariant?.name || product.name }}</strong>
          ?
        </p>
      </div>
    }

    @case (ProductClassifications.CustomerServiceProduct) {
      <div>
        <p><strong>Fjern fra bestillingen</strong></p>
        <p>
          Er du sikker på at du vil fjerne
          <strong>{{ product.customerServiceOffering?.name }}</strong>
          ?
        </p>
      </div>
    }

    @case (ProductClassifications.Owner) {
      <div>
        <p><strong>Fjern endringer på brukerinformasjon</strong></p>
        <p>
          Er du sikker på at du vil fjerne endringer på brukerinformasjon for
          <strong>{{ product?.fullname }}</strong>
          ?
        </p>
      </div>
    }
  }

  <div class="dialog-buttons" mat-dialog-actions>
    <app-ice-button
      class="button"
      color="secondary"
      testId="confirm-remove-product-button"
      width="100%"
      (click)="confirmRemoveProduct()"
    >
      {{ product.isExistingSubscription ? 'Fjern endringer' : 'Fjern' }}
    </app-ice-button>
    <app-ice-button class="button" color="outlined" matDialogClose testId="abort-remove-product-button" width="100%">
      Avbryt
    </app-ice-button>
  </div>
</div>
